import React, { useEffect, useRef, useState } from "react";
// import NavigationBar from "../NavBar";
import "../CSS/TamilLandingpage.css"
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa"
import whatsappIcon from "../Assets/Images/Tech/Icons/whatsap-white-icon.svg"
import { useLocation } from "react-router-dom";
// import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from 'libphonenumber-js';
import 'react-phone-input-2/lib/style.css'; // REQUIRED: without this the input won't appear

import advisorImage1 from "../Assets/Images/Tech/Course/why/4.png"
import advisorImage2 from "../Assets/Images/Tech/Course/why/6.png"
import advisorImage from "../Assets/Images/Tech/Course/why/3.png"
import advisorImage3 from "../Assets/Images/Tech/Course/why/2.png"
import arrow2 from "../Assets/Images/Tech/Course/why/compressed/arrow2.png"
import fans from "../Assets/Images/Tech/Course/why/compressed/6 fans.mp4"
import rate from "../Assets/Images/Tech/Course/why/compressed/02 rate.mp4"
import over from "../Assets/Images/Tech/Course/why/compressed/30-overpopulation.mp4"
import icon1 from "../Assets/Images/Tech/Course/icons/1.png"
import icon2 from "../Assets/Images/Tech/Course/icons/2.png"
import icon3 from "../Assets/Images/Tech/Course/icons/3.png"
import icon4 from "../Assets/Images/Tech/Course/icons/4.png"
import icon5 from "../Assets/Images/Tech/Course/icons/5.png"
import icon6 from "../Assets/Images/Tech/Course/icons/6.png"
import icon7 from "../Assets/Images/Tech/Course/icons/7.png"
// import { Button } from "@/components/ui/button";
import icon8 from "../Assets/Images/Tech/Course/icons/8.png"
import gifvid from "../Assets/Images/Tech/Course/hi video Pc.mp4"
import gifvidmob from "../Assets/Images/Tech/Course/hi video phone.mp4"
import whatsappIcon1 from "../Assets/Images/Tech/Icons/whatsapp.svg"
import homeTamil from "../Assets/Images/Tech/Course/website home page new.jpg"
import { Helmet } from "react-helmet";
import faqImg2 from "../Assets/Images/Tech/AboutUs/faq-video.mp4"
import us1 from "../Assets/Images/Tech/AboutUs/Why choose anglofone new.mp4"
import why1 from "../Assets/Images/Tech/AboutUs/1.png"
import why2 from "../Assets/Images/Tech/AboutUs/2.png"
import why3 from "../Assets/Images/Tech/AboutUs/3.png"
import why4 from "../Assets/Images/Tech/AboutUs/4.png"


const TamilLandingpage = () => {

    const [videoSrc, setVideoSrc] = useState(gifvid);
    const [translateValue, setTranslateValue] = useState(170);
    const [phone, setPhone] = useState('');

    const [seatsRemaining, setSeatsRemaining] = useState(getRandomSeats());
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        place: ""
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };
    const handleChanges = (value) => {
        setFormData((prev) => ({ ...prev, phone: value }));
    };


    const handleSubmited = async (e) => {
        e.preventDefault();

        const phoneWithPlus = '+' + formData.phone;
        if (!isValidPhoneNumber(phoneWithPlus)) {
            alert("Please enter a valid phone number.");
            return;
        }


        try {
            const response = await fetch('https://script.google.com/macros/s/AKfycbwFCCeZR4tvEfhkXtGvf6vR4_rLPItwLadfKJXrdsndP37Fp8kuZMWP7WMaWms3Mncywg/exec', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log("everyday", result);


            if (result.success) {
                alert("Submitted successfully!");
                setFormData({ name: "", email: "", phone: "", place: "" });
            } else {
                alert("Submission failed. Try again.");
            }
        } catch (error) {
            alert("Error submitting form: " + error.message);
        }
    };

    function getRandomSeats() {
        // Random number between 2 and 10 seats
        return Math.floor(Math.random() * 9) + 2;
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setSeatsRemaining(getRandomSeats());
        }, 30000); // update every 30 seconds (optional)

        return () => clearInterval(interval);
    }, []);

    // useEffect(() => {
    //     const slideGroups = [
    //         ['why-c1', 'why-c2', 'why-c3'],
    //         ['what-c1', 'what-c2', 'what-c3', 'what-c4', 'what-c5']
    //     ];

    //     const intervals = slideGroups.map((slides) => {
    //         let currentIndex = 0;
    //         return setInterval(() => {
    //             document.getElementById(slides[currentIndex]).checked = false;
    //             currentIndex = (currentIndex + 1) % slides.length;
    //             document.getElementById(slides[currentIndex]).checked = true;
    //         }, 5000);
    //     });

    //     return () => intervals.forEach(clearInterval);
    // }, []);


    useEffect(() => {
        const slideGroups = [
            ['why-c1', 'why-c2', 'why-c3'],
            ['what-c1', 'what-c2', 'what-c3', 'what-c4', 'what-c5']
        ];

        slideGroups.forEach((slides) => {
            slides.forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.checked = true; // Check all slides
            });
        });
    }, []);

    const [timeLeft, setTimeLeft] = useState(() => {
        const randomMinutes = Math.floor(Math.random() * (3 - 2 + 1)) + 2; // 2–3 minutes
        const randomSeconds = Math.floor(Math.random() * 60); // 0–59 seconds
        return (randomMinutes * 60) + randomSeconds;
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const formatTime = (seconds) => {

        const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `00:${m}:${s}`;

    };


    const icons = [<img src={icon3} alt="Icon 3" key="icon3" className="icon-image" />, <img src={icon2} alt="Icon 2" key="icon2" className="icon-image" />,
    <img src={icon1} alt="Icon 1" key="icon1" className="icon-image" />, <img src={icon8} alt="Icon 8" key="icon8" className="icon-image" />,
    <img src={icon7} alt="Icon 7" key="icon7" className="icon-image" />, <img src={icon6} alt="Icon 6" key="icon6" className="icon-image" />,
    <img src={icon5} alt="Icon 5" key="icon5" className="icon-image" />, <img src={icon4} alt="Icon 4" key="icon4" className="icon-image" />];
    const texts = ["Daily Video classes + Calls – தினமும் practise", "உங்க profession-க்கு தேவைப்படுற English training",
        "Everyday new words training", "Workplace & Daily Life Phrases – Easy English", "Fixed Timing இல்லை",
        "Personal Trainer Support", "British Council Certified Trainers", "2 Month Training + 10 Month Support"];
    const images = [advisorImage1, advisorImage2, advisorImage3, advisorImage];


    const loc = useLocation();
    const handleLanguageSelect = (languageUrl) => {
        // Directly navigate to the provided URL
        window.location.href = languageUrl;
    };


    const openWhatsApp = () => {
        window.open(
            "https://api.whatsapp.com/send?phone=919952389762&text=Hi%20Nivetha%2C%20I%20would%20like%20to%20know%20more%20about%20the%20course%20details.",
            "_blank"
        );
    };

    const [angleOffset, setAngleOffset] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [textOpacity, setTextOpacity] = useState(1);
    const [imageOpacity, setImageOpacity] = useState(1);
    const scrollref = useRef()

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeout(() => {
                setTextOpacity(0);
                setImageOpacity(0);
            }, 1200);


            setTimeout(() => {
                // Step 2: Change text when it's completely faded out (midpoint of animation)
                setActiveIndex((prevIndex) => (prevIndex + 1) % icons.length);
            }, 3900);

            setTimeout(() => {
                // Step 3: Rotate icons smoothly
                setAngleOffset((prevOffset) => prevOffset + 45);
            }, 2000);

            setTimeout(() => {
                setImageOpacity(1);
                setTextOpacity(1);
            }, 4000); // Fade-in begins before rotation stops

        }, 7000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const updateVideoSrc = () => {
            if (window.innerWidth < 768) {
                setVideoSrc(gifvidmob);
            } else {
                setVideoSrc(gifvid);
            }
        };

        updateVideoSrc(); // Call on load
        window.addEventListener("resize", updateVideoSrc);

        return () => window.removeEventListener("resize", updateVideoSrc);
    }, []);


    const [showArrow, setShowArrow] = useState(false);


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowArrow(true);
                console.log("scroll event");
            } else {
                setShowArrow(false);
                console.log("scroll event false");
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Email validation
        if (!isValidEmail(formData.email)) {
            alert("Please enter a valid email address.");
            return;
        }

        const phoneWithPlus = '+' + formData.phone;
        if (!isValidPhoneNumber(phoneWithPlus)) {
            alert("Please enter a valid phone number.");
            return;
        }

        // Proceed with form submission
        try {
            const response = await fetch(
                "https://rglvxgwa53.execute-api.ap-south-1.amazonaws.com/dev/PostLeadsForm",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const text = await response.text();
            const result = JSON.parse(text);

            if (result.statusCode == 200) {
                //   alert("Form submitted successfully!");
                window.location.href = "/tamil/Thank";
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    place: "",
                });
            } else {
                alert("Submission failed. Try again.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert("Error submitting form. Please try again later.");
        }
    };


    const scrolldown = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    };


    useEffect(() => {
        const updateTranslateValue = () => {
            setTranslateValue(window.innerWidth < 768 ? 75 : 170);
        };

        updateTranslateValue(); // Set value on mount
        window.addEventListener("resize", updateTranslateValue);

        return () => window.removeEventListener("resize", updateTranslateValue);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };


    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://www.instagram.com/embed.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (window.instgrm) {
                window.instgrm.Embeds.process();
            }
        }, 500);
    }, []);

    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        return regex.test(email);
    };



    return (
        <div>
            <Helmet>
                <title>Beginner English Course Online | Start Your Learning Journey</title>
                <meta name="description" content="Description: Start speaking English with Anglofone’s Beginner English lessons. Learn grammar, vocabulary, and everyday communication." />
                <meta name="keywords" content="Beginner English lessons" />
            </Helmet>

            <div>
                <section>




                    <div className="background-container">

                        {/* Background Image */}
                        <img src={homeTamil} alt="Background" className="background-image" />

                        <div className="row align-items-center justify-content-center text-start custom-row">
                            <div className="english-content col-lg-12 col-xl-12 col-md-12  d-flex flex-column align-items-start">
                                <div className="gotham-ultra">
                                    Master Spoken English In Tamil
                                </div>

                            </div>


                        </div>

                        {/* Overlay content */}
                        <div className="overlay-content">
                            <div className="limited-time-text">Limited Time Offer!</div>
                            <div className="countdown-timer">{formatTime(timeLeft)}</div>

                            {/* <div className="tton-now">
                                <a className="banner_link_1" onClick={openWhatsApp}>
                                    <span className="icon_wrapper_1">
                                        <img className="whatsup_1" src={whatsappIcon1} alt="WhatsApp Icon" />
                                    </span>
                                    <span className="text_wrapper_1">CLICK TO JOIN</span>
                                </a>
                            </div> */}

                            <a
                                // href="https://forms.gle/nudq1cjy4HAw7T5X6" 
                                target="_blank"
                                rel="noopener noreferrer"
                                className="book-seat-button"
                                onClick={() => scrolldown(scrollref)}

                            >
                                Join Now
                            </a>


                            <div className="seats-remaining">
                                Only <span className="seats-number">{seatsRemaining}</span> seats remaining!
                            </div>
                        </div>
                    </div>


                </section>



                <div className="mx-auto  boxinput" ref={scrollref}  >
                    <div className="mx-auto-heading-land-3  " style={{ color: "red" }}  >
                        Enroll <span className="theme-red-text"> Now</span>
                    </div>
                    <div className="d-flex justify-content-center">
                        <form
                            style={{ width: "90%", maxWidth: "500px" }}
                            onSubmit={handleSubmit}
                        >
                            <div className="form-group mb-3">
                                <label className="textform2" htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    //  style={{ borderColor:"yellow" }}
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label className="textform2" htmlFor="email">Email</label>

                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                    required
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                    title="Please enter a valid email address"
                                />




                            </div>

                            <div className="form-group mb-3">
                                {/* <label htmlFor="phone" style={{ color:"green" }} >WhatsApp Number</label> */}
                                <label className="textform" htmlFor="phone">What'sapp Number</label>
<div className="phone-input">
 <PhoneInput
                                    
                                    
                                    country={'in'}
                                    value={formData.phone}
                                    onChange={handleChanges}
                                    enableSearch={true}
                                    inputProps={{
                                        name: 'phone',
                                        required: true,
                                        id: 'phone',
                                        className:"form-control"
                                    }}
                                    
                                />

</div>
                               
                            </div>


                            {/* <div className="form-group mb-3">
                                <label className="textform" htmlFor="phone">What'sapp Number</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="phone"
                                    value={formData.phone}
                                     style={{ borderColor:"green" }}
                                    onChange={handleChange}
                                    placeholder="Enter your phone number"
                                    required
                                />
                            </div> */}

                            <div className="form-group mb-4">
                                <label className="textform2" htmlFor="city">City or District</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    // style={{ borderColor:"red" }}
                                    id="place"
                                    value={formData.place}
                                    onChange={handleChange}
                                    placeholder="Enter your Locality"
                                    required
                                />
                            </div>

                            <div className="text-center">
                                <button type="submit" className="btn btn-danger px-4 py-2" onClick={handleSubmit}  >
                                    Join Now
                                </button>
                            </div>
                        </form>
                    </div>
                </div>




                <div className="mx-auto">
                    <div className="mx-auto-heading-land">
                        Why Choose <span className="theme-red-text">Us?</span>
                    </div>
                    <section
                        className="section-why-choose-us d-flex justify-content-center align-items-center"

                    >

                        <div className="row" >

                            <div className="col-md-12">
                                <div className="wrapper_inside_land">
                                    <div className="container_inside_land" id="why-slider">
                                        <input type="checkbox" name="why-slide" id="why-c1" checked readOnly />
                                        <label htmlFor="why-c1" className="card1">
                                            <div className="row">

                                                <div className="decs_align">
                                                    <div className="desc">

                                                        <h4>Personalized 1-on-1 coching via WhatsApp</h4>
                                                    </div>
                                                </div>

                                            </div>
                                        </label>

                                        <input type="checkbox" name="why-slide" id="why-c2" checked readOnly />
                                        <label htmlFor="why-c2" className="card1">
                                            <div className="row">

                                                <div className="decs_align">
                                                    <div className="desc">
                                                        <h4>Flexible schedule - learn anytime,anywhere</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>

                                        <input type="checkbox" name="why-slide" id="why-c3" checked readOnly />
                                        <label htmlFor="why-c3" className="card1">
                                            <div className="row">

                                                <div className="decs_align">
                                                    <div className="desc">
                                                        <h4>Free level test and customized learning plan</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>

                <div className="mx-auto">
                    <div className="mx-auto-heading-land-2">
                        What You  <span className="theme-red-text">Get</span>
                    </div>
                    <section
                        className="section-why-choose-us d-flex justify-content-center align-items-center"

                    >

                        <div className="row" >

                            <div className="col-md-12">
                                <div className="wrapper_inside_land">
                                    <div className="container_inside_land2" id="what-slider">
                                        <input type="checkbox" name="what-slide" id="what-c1" checked readOnly />
                                        <label htmlFor="what-c1" className="card1">
                                            <div className="row">
                                                <div className="decs_align">
                                                    <div className="desc">

                                                        <h4>2-month intensive spoken English program</h4>
                                                    </div>
                                                </div>

                                            </div>
                                        </label>

                                        <input type="checkbox" name="what-slide" id="what-c2" checked readOnly />
                                        <label htmlFor="what-c2" className="card1">
                                            <div className="row">

                                                <div className="decs_align">
                                                    <div className="desc">
                                                        <h4>10 months of  extended trainer support</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>

                                        <input type="checkbox" name="what-slide" id="what-c3" checked readOnly />
                                        <label htmlFor="what-c3" className="card1">
                                            <div className="row">

                                                <div className="decs_align">
                                                    <div className="desc">
                                                        <h4>doubt-clearing sessions</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>

                                        <input type="checkbox" name="what-slide" id="what-c4" checked readOnly />
                                        <label htmlFor="what-c4" className="card1">
                                            <div className="row">

                                                <div className="decs_align">
                                                    <div className="desc">
                                                        <h4>Daily speaking practice with experts</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                        <input type="checkbox" name="what-slide" id="what-c5" checked readOnly />
                                        <label htmlFor="what-c5" className="card1">
                                            <div className="row">
                                                <div className="decs_align">
                                                    <div className="desc">
                                                        <h4>Certificate upon completion</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <div className="mx-auto  boxinput"  >
                    <div className="mx-auto-heading-land-3  " style={{ color: "red" }}  >
                        Enroll <span className="theme-red-text"> Now</span>
                    </div>
                    <div className="d-flex justify-content-center">
                        <form
                            style={{ width: "90%", maxWidth: "500px" }}
                            onSubmit={handleSubmit}
                        >
                            <div className="form-group mb-3">
                                <label className="textform2" htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    //  style={{ borderColor:"yellow" }}
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>

                            <div className="form-group mb-3">

                                <label className="textform2" htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={formData.email}
                                    //  style={{ borderColor:"blue" }}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label className="textform" htmlFor="phone">What'sapp Number</label>
                                <PhoneInput
                                    
                                    country={'in'}
                                    value={formData.phone}
                                    onChange={handleChanges}
                                    enableSearch={true}
                                    inputProps={{
                                        name: 'phone',
                                        required: true,
                                        id: 'phone',
                                        className:"form-control"
                                    }}
                                    containerStyle={{ marginBottom: '15px' }}
                                /></div>



                            <div className="form-group mb-4">
                                <label className="textform2" htmlFor="city">City or District</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    // style={{ borderColor:"red" }}
                                    id="place"
                                    value={formData.place}
                                    onChange={handleChange}
                                    placeholder="Enter your Locality"
                                    required
                                />
                            </div>

                            <div className="text-center">
                                <button type="submit" className="btn btn-danger px-4 py-2" onClick={handleSubmit}  >
                                    Join Now
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                {showArrow && (
                    <button
                        className="back-to-top"
                        onClick={scrollToTop}
                        aria-label="Back to top"
                    >
                        ↑
                    </button>
                )}

                <section className="section-why-choose-us section-testimonial-1">
                    <div className="container what-people">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h2>
                                    Student <span className="text-primary">Reviews</span>
                                </h2>
                            </div>
                                                       <div className="col-md-12" style={{ border: 'none' }}>
                                {/* Elfsight Google Reviews Widget */}
                                <div
                                    className="elfsight-app-055282d1-f470-44fa-8a59-32cb680bd8ea"
                                    data-elfsight-app-lazy
                                    style={{ width: '100%', minHeight: '400px', marginTop: '30px' }}
                                ></div>
                            </div>
                            <div className="col-md-12 text-center" style={{ marginTop: '0px' }}>
                                <h2>
                                    Success <span className="text-primary">Stories</span>
                                </h2>


                                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
                                    <blockquote
                                        className="instagram-media"
                                        data-instgrm-permalink="https://www.instagram.com/reel/DJtxUbHSY1k/"
                                        data-instgrm-version="14"
                                        style={{ maxWidth: '300px', width: '100%' }}
                                    ></blockquote>

                                    <blockquote
                                        className="instagram-media"
                                        data-instgrm-permalink="https://www.instagram.com/reel/DJooxqZpevu/?utm_source=ig_web_button_share_sheet"
                                        data-instgrm-version="14"
                                        style={{ maxWidth: '300px', width: '100%' }}
                                    ></blockquote>

                                    <blockquote
                                        className="instagram-media"
                                        data-instgrm-permalink="https://www.instagram.com/reel/DJZjlxjS5Xd/?utm_source=ig_web_button_share_sheet"
                                        data-instgrm-version="14"
                                        style={{ maxWidth: '300px', width: '100%' }}
                                    ></blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>




            </div>
            {/* <footer>
                <Footer />
            </footer> */}
        </div >

    )
}

export default TamilLandingpage;